import types from '../types';

const state = {
  breadcrumb: []
}

const mutations = {
  [types.SET_BREADCRUMB](state, breadcrumb) {
    if (breadcrumb) {
      state.breadcrumb = breadcrumb;
    } else {
      state.breadcrumb = [];
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/nav.js